export default __webpack_public_path__ + "static/media/ex_blog1.7e6769ae.png";